export function covertTreeData(list, parentBusiCode) {
  const res = []
  list.forEach(item => {
      if(item==null){
      }else{
        if (item.parentId == parentBusiCode) {
          const children = covertTreeData(list, item.orgId)
          if (children.length > 0) {
              item.children = children
          }
          res.push(item)
      }
      }

  })
  return res
}
export function treeListToList(treeList) { // 将树结构的列表转换为普通列表
  let list = [];
  handleTreeList(treeList, list);
  return list
}
function handleTreeList(treeList, list) { 
if (!treeList || !treeList.length) {
  return
}
for (let i = 0; i < treeList.length; i++) {
  let currentRow = treeList[i];
  let newRow = JSON.parse(JSON.stringify(currentRow));
  newRow.children = undefined;
  list.push(newRow);
  handleTreeList(currentRow.children, list)//递归
}
}

export function setKeys(listData,keys,value){//vue双向绑定原理构造嵌套对象属性值
  var list = {};
  var arr = listData;
  for (var key in arr) {
      list[key] = arr[key];
  }
  for (let keys in list) {

      if(list[keys].busiCode != keys){
          let keyName = list[keys].busiCode.toString();
          // console.log(keyName)
          Object.defineProperty(list, keyName, {
              value : list[keys],
              writable : true,//写
              enumerable : true,//修改
              configurable : true//枚举
          });
          delete list[keys]
      }
}
return list
//   console.log(list)
}
export function getTreeLabelFn(list) {
for (let i = 0; i < list.length; i++) {
    list[i].disabled = false
    list[i].label = list[i].name
    if (list[i].isType == 1) {
        getTreeLabelFn(list[i].children)
    } else {
        list[i].userId = list[i].id
        list[i].id = list[i].parentId + '-' + list[i].id
        list[i].agentName = list[i].name
    }
}
return list
}
export function distinct(arr, o) {//去重
var i, j,
    len = arr.length;
for (i = 0; i < len; i++) {
    for (j = i + 1; j < len; j++) {
        if (arr[i][o] == arr[j][o]) {
            arr.splice(j, 1);
            len--;
            j--;
        }
    }
}
return arr;
}
export function  setShowHideFn(datalist, nodes, key, disabled) { // 树组件---递归处理显示隐藏左侧数据
  const forStr = function (list) {
      for (let i = 0; i < list.length; i++) {
          nodes.map((o) => {
              if (list[i][key] && o[key] == list[i][key]) {
                  list[i].disabled = disabled
              }
          })
          if (list[i].children) {
                forStr(list[i].children)
          }
      }
  }
  forStr(datalist)
}

export function findItem(arr,key,val) {
  for(let i = 0; i < arr.length; i++) {
      if(arr[i][key] == val) {
          return i
      }
  }
  return -1
}

export function getParentKey(treeData,id){
  let allparents = [];
  let allparentsName = [];
  if(treeData.length==0){
    return 
  }

  let findele = (data,id) => {
    if(!id) return
    data.forEach((item,index) => {
      if(item.dictId == id){
        allparents.unshift(item.dictId)
        allparentsName.unshift(item.dictName)
        findele(treeData,item.parentId)

      }else{
        if(item.childData){
            findele(item.childData,id)
        }
        
      }
    })
  }

  findele(treeData,id)
  let dataObject = {
    'codeList':allparents,
    'nameList':allparentsName,

  }
  return dataObject
}


export function specialHandling(treeData,id){//特殊处理人员部门
  let allparents = [];
  if(treeData.length==0){
    return 
  }
  let findele = (data,id) => {
    if(!id) return
    data.forEach((item,index) => {
      if(item.orgId == id){
        allparents.unshift(item.orgId)
        findele(treeData,item.parentId)

      }else{
        if(!!item.children){
            findele(item.children,id)
        }
      }
    })
  }
  findele(treeData,id)
  return allparents
}

export function formatTableData(name, row){//回填表格数据
  let dictValue = '', obj = {}, returnStr = ''
  let optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
  let statusList = {
    0: '暂存', 1: '开启', 2: '已分配', 3: '处理中', 4: '已解决', 5: '回访中', 6: '待回访', 7: '已回访', 8: '关闭'
  }
  
  let getTreeName = (list, groupId) => {
    for (let i = 0; i < list.length; i++) {
      let a=list[i]
      if(a.orgId===groupId){
        return a.orgName
      }else{
        if(a.children && a.children.length>0){
          let res = getTreeName(a.children,groupId)
          if(res) return res
        }
      }
    }
  }
  
  //工单类型
  if (name == 'orderTypeCode') {
    dictValue = 'orderType'
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.code == row.orderTypeCode)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.name
    else returnStr = row.orderTypeCode
  }
  //优先级
  if (name == 'priorityCode') {
    dictValue = 'priorityCode'
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.code == row.priorityCode)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.name
    else returnStr = row.priorityCode
  }
  //客户等级
  if (name == 'levelCode') {
    dictValue = 'cusLevel'
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.code == row.levelCode)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.name
    else returnStr = row.levelCode
  }
  //部门
  if (name == 'groupId') {
    dictValue = 'orgList' 
    if (dictValue in optionList) obj = getTreeName(optionList[dictValue], row.groupId)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj
    else returnStr = row.groupId
  }
  //创建人
  if (name == 'createOper') {
    dictValue = 'userList' 
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.userId == row.createOper)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.agentName
    else returnStr = row.createOper
  }
  //人员
  if (name == 'userId') {
    dictValue = 'userList' 
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.userId == row.userId)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.agentName
    else returnStr = row.userId
  }
  //客户
  if (name == 'cusId') {
    dictValue = 'customer'
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.id == row.cusId)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.cusName
    else returnStr = row.cusId
  }
  //公司
  if (name == 'cId') {
    dictValue = 'cusCompany'
    if (dictValue in optionList) obj = optionList[dictValue].find(oItem => oItem.id == row.cId)
    if(obj&&JSON.stringify(obj) != '{}') returnStr = obj.name
    else returnStr = row.cId
  }
  //工单状态
  if (name == 'status') {
    returnStr = statusList[row.status]
  }
  return returnStr
}


// WEBPACK FOOTER //
// ./src/utils/auth.js